import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=6e5c06db&scoped=true&"
import script from "./Downloads.vue?vue&type=script&lang=ts&"
export * from "./Downloads.vue?vue&type=script&lang=ts&"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=6e5c06db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5c06db",
  null
  
)

export default component.exports